<template>
  <div class="container">
    <div class="card">
      <img src="@/assets/logo.png" alt="公司Logo" class="logo">
      <span>凯尚设计</span>
      <div class="content-wrapper">
        <div class="wechat-section">
          <div class="wechat-info">
            <i class="icon-wechat"></i>
            <span class="wechat-id">m418257058</span>
          </div>
          <button class="btn copy-btn" @click="copyWechatId">
            <i class="icon-copy"></i>
            复制微信号
          </button>
        </div>

        <div class="qr-code-section">
          <button class="btn qr-btn" @click="showQRModal = true">
            <i class="icon-qrcode"></i>
            添加客服微信
          </button>
        </div>

        <div class="service-hours">
          <h3>服务时间</h3>
          <p>周一至周五: 9:00 - 18:00</p>
          <p>周六至周日: 10:00 - 16:00</p>
        </div>
      </div>
    </div>

    <!-- QR Code Modal -->
    <div class="modal" v-if="showQRModal">
      <div class="modal-content">
        <span class="close-btn" @click="showQRModal = false">&times;</span>
        <img src="@/assets/wx.jpg" alt="微信二维码" class="qr-code-modal">
        <p class="modal-text">请使用微信扫描上方二维码添加我们</p>
      </div>
    </div>

    <!-- Toast Notification -->
    <div class="toast" :class="{ 'show': showToast }">
      <span>微信号已复制到剪贴板</span>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  title: '添加客服',
  setup() {
    const wechatId = ref('m418257058');
    const showQRModal = ref(false);
    const showToast = ref(false);

    const copyWechatId = async () => {
      try {
        await navigator.clipboard.writeText(wechatId.value);
        showToast.value = true;
        setTimeout(() => {
          showToast.value = false;
        }, 2000);
      } catch (err) {
        console.error('复制失败:', err);
      }
    };

    return {
      wechatId,
      showQRModal,
      showToast,
      copyWechatId
    };
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 20px;
  font-family: 'Segoe UI', sans-serif;
}

.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
}

.logo {
  width: 140px;
  height: 140px;
  margin: 24px auto 16px;
  display: block;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.content-wrapper {
  padding: 24px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 微信号展示区域 */
.wechat-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f7fbfa;
  border-radius: 10px;
  border: 1px solid #d9f1e7;
}

.wechat-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
}

.icon-wechat::before {
  content: "\e727"; /* 示例 Unicode 字符，可根据图标库调整 */
  font-size: 22px;
  color: #07c160;
}

.copy-btn {
  background-color: #07c160;
  color: white;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease-in-out;
  border: none;
}

.copy-btn:hover {
  background-color: #05ad56;
  transform: translateY(-2px);
}

/* 二维码区域 */
.qr-code-section {
  text-align: center;
}

.qr-btn {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease-in-out;
}

.qr-btn:hover {
  background-color: #147ad6;
  transform: translateY(-2px);
}

/* 服务时间区域 */
.service-hours {
  margin-top: auto;
  border-top: 1px solid #e8e8e8;
  padding-top: 18px;
}

.service-hours h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.service-hours p {
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
}

/* 模态框 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 28px;
  text-align: center;
  max-width: 320px;
  width: 90%;
  position: relative;
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 24px;
  cursor: pointer;
  color: #aaa;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #333;
}

.qr-code-modal {
  width: 220px;
  height: 220px;
  margin: 16px auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modal-text {
  color: #777;
  font-size: 14px;
  margin-top: 10px;
}

/* Toast 提示 */
.toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  z-index: 1001;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.toast.show {
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .card {
    padding: 16px;
  }

  .logo {
    width: 110px;
    height: 110px;
  }

  .content-wrapper {
    padding: 16px;
  }

  .qr-code-modal {
    width: 180px;
    height: 180px;
  }
}
</style>
